import React, { Component, Fragment } from 'react';
import { createPortal } from 'react-dom';
import { Manager, Reference, Popper } from 'react-popper';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { array, func, bool } from 'prop-types';
import StatisticsPresetsList from './StatisticsPresetsList';
import Icon from '../Icon/Icon';
import SVG from 'react-inlinesvg';
import PresetModal from '../../modals/PresetModal/PresetModal';
import WithPlaceholder from '../../hoc/WithPlaceholder';
import StatisticsPresetForm from './StatisticsPresetForm';
import { STATIC_PATH } from '../../config';

class StatisticsPresets extends Component {
  static propTypes = {
    presets: array.isRequired,
    onSelectPreset: func.isRequired,
    onRemovePreset: func.isRequired,
    mobileModal: bool,
  };

  static defaultProps = {
    presets: [],
    selected: 'default',
    mobileModal: false,
  };

  constructor(props) {
    super(props);

    const selected =
      props.selected === 'default' ? {} : props.presets.find(({ id }) => id === props.selected);

    this.state = {
      open: false,
      selected: selected || {},
      q: '',
      popover: false,
      errors: {},
    };

    this.$el = React.createRef();
    this.$popover = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideInteraction);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideInteraction);
  }

  handleOutsideInteraction = ({ target }) => {
    if (this.props.mobileModal) {
      return;
    }

    const { open } = this.state;
    const presets = this.$el.current;
    const popover = this.$popover.current;
    const removeConfirmation = document.querySelector('.statistics-presets-modal');

    if (
      open &&
      (!presets || !presets.contains(target)) &&
      (!popover || !popover.contains(target)) &&
      (!removeConfirmation || !removeConfirmation.contains(target))
    ) {
      this.setState(() => ({ open: false }));
    }
  };

  toggle = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  handleChange = ({ target }) => {
    this.setState(() => ({ [target.name]: target.value }));
  };

  handleSelect = (id) => {
    const selected = this.props.presets.find((preset) => preset.id === id) || {};

    this.setState(
      () => ({ open: false, selected }),
      () => {
        const { id, filter } = this.state.selected;

        try {
          this.props.onSelectPreset(JSON.parse(filter), id);
        } catch (e) {
          this.props.onSelectPreset({}, 'default');
        }
      },
    );
  };

  openPopover = () => {
    this.setState(() => ({ popover: true }));
  };

  closePopover = () => {
    this.setState(() => ({ popover: false }));
  };

  handleAddPreset = (title) => {
    this.closePopover();
    this.props.onSavePreset(null, title);
  };

  getFilteredPresets = () => {
    const { q } = this.state;
    const { presets } = this.props;

    if (q.length === 0) {
      return presets;
    }

    return presets.filter(({ title }) => title.includes(q));
  };

  renderPresetsContent = () => {
    const { q } = this.state;

    return (
      <Fragment>
        <div className="statistics-presets-search">
          <Icon type="search" />

          <WithPlaceholder
            bsSize="sm"
            name="q"
            placeholder="main.search"
            defaultMessage="search"
            onChange={this.handleChange}
            value={q}
            autoComplete="off"
          />
        </div>

        <StatisticsPresetsList
          presets={this.getFilteredPresets()}
          onSelect={this.handleSelect}
          onRemove={this.props.onRemovePreset}
        />
      </Fragment>
    );
  };

  render() {
    const { open, selected, popover } = this.state;
    const { mobileModal } = this.props;

    return (
      <Fragment>
        <Manager>
          <div className="statistics-presets" ref={this.$el}>
            <Reference>
              {({ ref }) => (
                <button
                  type="button"
                  ref={ref}
                  className={`statistics-filter-button btn btn-outline-light btn-sm btn-toggler${
                    open ? ' active' : ''
                  }`}
                  onClick={this.toggle}
                  aria-expanded={open}
                >
                  {!!selected.title ? (
                    selected.title
                  ) : (
                    <FormattedMessage
                      id="statistics.preset.custom"
                      defaultMessage="Custom filter"
                    />
                  )}

                  <i className="dropdown-toggle" />
                </button>
              )}
            </Reference>

            {open &&
              !mobileModal &&
              createPortal(
                <Popper placement="bottom">
                  {({ ref, style, placement, arrowProps }) => (
                    <div
                      className="statistics-presets-container"
                      ref={(node) => {
                        ref(node);
                        this.$popover.current = node;
                      }}
                      style={style}
                      data-placement={placement}
                    >
                      {this.renderPresetsContent()}
                      <span className="arrow" ref={arrowProps.ref} style={arrowProps.style} />
                    </div>
                  )}
                </Popper>,
                document.body,
              )}

          </div>
        </Manager>

        <button
          className="save-preset-btn"
          type="button"
          id="add-preset-btn"
          onClick={this.openPopover}
        >
          <SVG
            src={`${STATIC_PATH}/img/action-icons/filter-icon.svg`}
            height="20"
            width="20"
            cacheRequests
          />
        </button>

        {mobileModal && (
          <Modal
            isOpen={open}
            toggle={this.toggle}
            centered
            autoFocus
            className="statistics-filter-modal statistics-presets-mobile-modal"
          >
            <ModalHeader toggle={this.toggle}>
              <FormattedMessage
                id="statistics.preset.custom"
                defaultMessage="Custom filter"
              />
            </ModalHeader>
            <ModalBody>{this.renderPresetsContent()}</ModalBody>
          </Modal>
        )}

        <PresetModal open={popover} onSave={this.handleAddPreset} onCancel={this.closePopover} />

        {/* <StatisticsPresetForm
          open={popover}
          onSave={this.handleAddPreset}
          onCancel={this.closePopover}
          target="add-preset-btn"
        /> */}

        {/* <UncontrolledTooltip placement="top" target="add-preset-btn">
          <FormattedMessage
            id="statistics.filters.presets.tooltip"
            defaultMessage="Creating a filter template"
          />
        </UncontrolledTooltip> */}
      </Fragment>
    );
  }
}

export default StatisticsPresets;
